"use client";

import { motion } from "framer-motion";
import { Monitor, Users, Server, LifeBuoy } from "lucide-react";

const useCases = [
  {
    icon: Monitor,
    title: "Solo dev with a Mac mini",
    description: "Local Clawbiz on Mac mini. WhatsApp + Telegram connected. File + shell skills; code, notes, and browser automation.",
  },
  {
    icon: Users,
    title: "Small team on a shared VPS",
    description: "Clawbiz on a VPS with multiple channels (Slack workspace, Discord server). Team-wide memory across chats. Shared skills for ops, deployments, docs.",
  },
  {
    icon: Server,
    title: "Ops person with remote desktop",
    description: "Clawbiz on Windows box in datacenter/LAB. WhatsApp + desktop chat as frontends. Shell and browser skills to manage infra consoles.",
  },
  {
    icon: LifeBuoy,
    title: "Already-broken install",
    description: "Legacy install + partial upgrade, clashing services. We clean up, re-install, re-link channels, keep your data where possible.",
  },
];

export const UseCasesSection = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-6xl mx-auto space-y-12">
          <motion.div
            className="text-center space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-3xl md:text-5xl font-display font-medium leading-tight">
              Example <span className="gradient-text-cyan">setups</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              High-signal patterns, not generic SaaS personas.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-5">
            {useCases.map((uc, index) => {
              const Icon = uc.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.08 }}
                  className="relative group"
                >
                  <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-br from-[hsl(var(--cyan-bright)/0.1)] to-[hsl(var(--coral-bright)/0.08)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <div className="relative glass-card rounded-2xl p-6 space-y-4 hover:bg-white/[0.03] transition-all duration-300">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[hsl(var(--cyan-bright)/0.15)] to-[hsl(var(--coral-bright)/0.08)] flex items-center justify-center">
                      <Icon className="w-5 h-5 text-[hsl(var(--cyan-bright))]" />
                    </div>
                    <h3 className="text-lg font-display font-medium">{uc.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{uc.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
